<template>
    <div>
        <auth-container :page="page">
            <h2 class="mb-4">Project Status</h2>

            <b-row>
                <b-col md="4">
                    <b-table-simple>
                        <b-thead class="bg-light">
                            <b-tr>
                                <b-th>Status</b-th>
                                <b-th># Projects</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(s, i) in data.statuses" :key="i">
                                <b-td>{{s.name}}</b-td>
                                <b-td>{{s.total}}</b-td>
                            </b-tr>
                        </b-tbody>
                        <b-tfoot>
                            <b-tr class="bg-light">
                                <b-td>Total # of Projects</b-td>
                                <b-td>{{data.total}}</b-td>
                            </b-tr>
                        </b-tfoot>
                    </b-table-simple>
                </b-col>
                <b-col md>
                    <highcharts :options="statusesPieChart"></highcharts>
                </b-col>
            </b-row>

            <h3 class="mt-4 mb-2">Number of Projects Completed by Year</h3>
            <p>
                Completion letter submission date must be filled to be included in this report.
            </p>

            <b-table-simple>
                <b-thead class="bg-light">
                    <b-tr>
                        <b-th>Year</b-th>
                        <b-th># Projects</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(s, i) in data.yearCompleted" :key="i">
                        <b-td>{{s.year}}</b-td>
                        <b-td>{{s.total}}</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </auth-container>
    </div>
</template>

<script>
    export default {
        name: 'SrReportProjectStatus',
        data() {
            return {
                page: {
                    errors: [],
                    loading: true,
                    showLogin: false,
                },
                data: {
                    statuses: [],
                    yearCompleted: [],
                    total: 0,
                }
            }
        },
        async created() {
            await this.get();
        },
        watch: {
            '$route': 'get',
        },
        methods: {
            async get() {
                this.page.errors = [];
                this.page.loading = true;

                try {
                    const response = await this.$http.get(`srreports/projectstatus`, this.getTokenHeader());
                    this.log(response.data);
                    this.data = response.data;
                } catch (error) {
                    if (this.isApiUnauthorized(error)) this.page.showLogin = true;
                    else this.page.errors = this.logError(error);
                }

                this.page.loading = false;
            },
        },
        computed: {
            statusesPieChart() {
                let data = [];
                for (let d of this.data.statuses) {
                    data.push([`${d.name}: ${d.total}`, this.roundAsNumber(d.total / this.data.total * 100, 1)]);
                }

                return {
                    chart: {
                        type: 'pie'
                    },
                    title: {
                        text: `Overall Status`
                    },
                    tooltip: {
                        pointFormat: '{point.percentage:.1f}%'
                    },
                    plotOptions: {
                        pie: {
                            innerSize: '50%'
                        }
                    },
                    series: [{
                        name: 'Status',
                        data: data
                    }]
                }
            },
        }
    }
</script>